import { ArrowRightIcon } from "@phosphor-icons/react";
import type { PropsWithChildren } from "react";

import { RequiredLabel } from "@/features/flights/components/additional-services/RequiredLabel";
import { getCityNameByAirportCode } from "@/features/flights/components/flight-purchase/additional-services/utils";
import type { MappedServiceData } from "@/features/flights/components/flight-purchase/AdditionalServicesSelection/types";
import type { GetFlightAvailabilityTokenOutputDataV2 } from "@/types/codegen";

type Props = PropsWithChildren<{
  routeCodes: string[];
  services: MappedServiceData[];
  flightDetails?: GetFlightAvailabilityTokenOutputDataV2;
}>;

export const RouteCard = ({
  routeCodes,
  services,
  flightDetails,
  children,
}: Props) => (
  <div className="relative flex flex-col gap-4 rounded-3xl bg-white p-4">
    {services.some((s) => s.mandatory) ? <RequiredLabel /> : null}
    <div className="flex items-center justify-start gap-1 text-lg">
      <div>
        {getCityNameByAirportCode(routeCodes[0], flightDetails?.flights)}
      </div>
      <ArrowRightIcon
        size={14}
        color="var(--color-black)"
        className="rtl:-scale-x-100"
      />
      <div>
        {getCityNameByAirportCode(routeCodes[1], flightDetails?.flights)}
      </div>
    </div>
    {children}
  </div>
);
